import React, { Component } from 'react';
import { Card } from 'react-bootstrap';

export default class SkillsCard extends Component {
  skills = this.props.skills.map(skill => {
    return <li>{skill.name}</li>;
  });
  render() {
    return (
      <Card>
        <Card.Header>{this.props.heading}</Card.Header>
        <Card.Text>
          <ul>{this.skills}</ul>
        </Card.Text>
      </Card>
    );
  }
}
